<template>
  <div class="mypage-one-time-pass-input-page">
    <sub-header-section :pageTitle="$tc('MypagePage.MypageOneTimePass.pageTitle')" />

    <one-time-pass-input-pane
      class="mypage-one-time-pass-input-page__content"
      @handlerSubmit="moveToOneTimePassConfirm"
    />

    <action-buttons-section
      scrollTargetSelector=".mypage-one-time-pass-input-page__content"
      :visible="true"
    >
      <atom-router-button to="/mypage" :linkText="$tc('common.back')" colorType="tertiary" />
    </action-buttons-section>

    <global-navigation-pane current="mypage" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import OneTimePassInputPane from '@/components/MypageOneTimePassInputPage/OneTimePassInputPane.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'
import ActionButtonsSection from '@/components/common/form/ActionButtonsSection.vue'
import AtomRouterButton from '@/components/atoms/AtomRouterButton.vue'
import StoreUtil from '@/store/StoreUtil'

/**
 * ブラウザ版: マイページ: ワンタイムパス: 入力ページ
 */
export default defineComponent({
  name: 'MypageOneTimePassInputPage',
  components: {
    AtomRouterButton,
    ActionButtonsSection,
    GlobalNavigationPane,
    OneTimePassInputPane,
    SubHeaderSection,
  },
  setup() {
    const oneTimePassPageStore = StoreUtil.useStore('OneTimePassPageStore')
    const { fetchContractPlans } = oneTimePassPageStore

    const fetch = async () => {
      /** SFgo組織の契約プラン情報を取得する（ログイン状態であることが前提） */
      await fetchContractPlans()
    }
    fetch()
  },
  methods: {
    /**
     * ワンタイムパスの登録確認画面へ遷移
     */
    moveToOneTimePassConfirm() {
      this.$router.replace({ name: 'MypageOneTimePassConfirmPage' })
    },
  },
})
</script>

<style lang="scss">
.page-wrapper {
  .mypage-one-time-pass-input-pane {
    max-width: 800px;
    padding-top: 58px;
  }
}
</style>
